import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";

function Slider() {
  return (
    <>
      <section className="slider-one">
        <Swiper
          effect="fade"
          loop={true}
          className="swiper-container"
        >
          {/* Slide 1 */}
          <SwiperSlide>
            <div className="slider-one__item">
              <div
                className="slider-one__image"
                style={{
                  backgroundImage: "url(assets/images/background/slider-1-1.jpg)",
                }}
              />
              <div className="container">
                <p className="slider-one__text">Welcome to Insuco</p>
                <h2 className="slider-one__title">Let’s Grow your future together</h2>
                <div className="slider-one__btns">
                  <Link to="/about" className="thm-btn thm-btn--three slider-one__btn">
                    <span>
                      Get Started
                      <i className="far fa-arrow-right" />
                    </span>
                  </Link>
                  <Link
                    to="/about"
                    className="thm-btn thm-btn--three slider-one__btn slider-one__btn--two"
                  >
                    <span>
                      Learn More
                      <i className="far fa-arrow-right" />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
            <div className="slider-one__item">
              <div
                className="slider-one__image"
                style={{
                  backgroundImage: "url(assets/images/background/slider-1-2.jpg)",
                }}
              />
              <div className="container">
                <p className="slider-one__text">Welcome to Insuco</p>
                <h2 className="slider-one__title">Let’s Grow your future together</h2>
                <div className="slider-one__btns">
                  <Link to="/about" className="thm-btn thm-btn--three slider-one__btn">
                    <span>
                      Get Started
                      <i className="far fa-arrow-right" />
                    </span>
                  </Link>
                  <Link
                    to="/about"
                    className="thm-btn thm-btn--three slider-one__btn slider-one__btn--two"
                  >
                    <span>
                      Learn More
                      <i className="far fa-arrow-right" />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
            <div className="slider-one__item">
              <div
                className="slider-one__image"
                style={{
                  backgroundImage: "url(assets/images/background/slider-1-3.jpg)",
                }}
              />
              <div className="container">
                <p className="slider-one__text">Welcome to Insuco</p>
                <h2 className="slider-one__title">Let’s Grow your future together</h2>
                <div className="slider-one__btns">
                  <Link to="/about" className="thm-btn thm-btn--three slider-one__btn">
                    <span>
                      Get Started
                      <i className="far fa-arrow-right" />
                    </span>
                  </Link>
                  <Link
                    to="/about"
                    className="thm-btn thm-btn--three slider-one__btn slider-one__btn--two"
                  >
                    <span>
                      Learn More
                      <i className="far fa-arrow-right" />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>
    </>
  );
}

export default Slider;
